import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_SETTINGS = {
    hero_headline: "Land.\nUnlocked.",
    hero_subheading: "Verde 2050 is a technology-driven land development and investment platform, combining capital, AI, and local expertise to unlock the potential of land across Portugal.",
    intro_text: "We're building a new generation of land development company. Combining AI, technology, local expertise and capital, we identify opportunities others overlook, unlock development potential and bring projects to market — investing alongside our partners.",
    contact_email: "hello@verde2050.com",
    instagram_url: "https://www.instagram.com/pietervanherpen/",
    instagram_handle: "@pietervanherpen",
    taylor_brokers_url: "https://www.taylorbrokers.com/",
    verde_capital_url: "https://www.verdecapital.eu/",
    nicoline_url: "https://www.nicolinebeerkens.com/",
    news_url: "https://news.verde2050.com",
    linkedin_url: "https://www.linkedin.com/company/verde-2050",
    walk_videos: [],
    ic_hero_image: "",
    ic_walk_image: "",
};

let cache = null;
let inflight = null;
const listeners = new Set();

export function refreshSettings() {
    inflight = api.get("/settings").then(({ data }) => {
        cache = { ...DEFAULT_SETTINGS, ...data };
        listeners.forEach((fn) => fn(cache));
        return cache;
    }).catch(() => cache || DEFAULT_SETTINGS);
    return inflight;
}

export function useSettings() {
    const [s, setS] = useState(cache || DEFAULT_SETTINGS);
    useEffect(() => {
        listeners.add(setS);
        if (!cache && !inflight) refreshSettings();
        return () => listeners.delete(setS);
    }, []);
    return s;
}

export const CONSENT_KEY = "v2050_cookie_consent";

export function track(event, label = "") {
    try {
        if (localStorage.getItem(CONSENT_KEY) !== "accepted") return;
        api.post("/track", { event, label, path: window.location.pathname }).catch(() => {});
    } catch { /* noop */ }
}

export const PROJECT_STATUSES = ["Exploring", "In Development", "Licensing", "Approved", "For Sale", "Completed"];

export const INQUIRY_TYPES = [
    { value: "I want to invest", key: "invest" },
    { value: "I have land to sell", key: "sell-land" },
    { value: "I'm looking for land", key: "find-land" },
    { value: "I'm interested in a development project", key: "project" },
    { value: "I need development financing", key: "financing" },
    { value: "I want to use Land Intelligence", key: "land-intelligence" },
    { value: "General inquiry", key: "general" },
];

export function useProjects() {
    const [projects, setProjects] = useState(null);
    useEffect(() => {
        api.get("/projects").then(({ data }) => setProjects(data)).catch(() => setProjects([]));
    }, []);
    return projects;
}
